<template>
  <section>
    <el-container>
      <el-header>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">交互中心</el-breadcrumb-item>
          <el-breadcrumb-item>电王标准对接</el-breadcrumb-item>
        </el-breadcrumb>
      </el-header>
      <el-main>
        <el-tabs v-model="groupInformationManagementTableModel" type="border-card" @tab-click="handleTab">
          <el-form :inline="true" :model="groupInformationManagementForm" class="user-search" size="mini">
            <el-form-item label="">
              <el-input v-model="groupInformationManagementForm.ownCarrier" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-input v-model="groupInformationManagementForm.affiliatedGroup" placeholder=""></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="groupInformationManagementForm.ownCarrier" placeholder="请选择">
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search">查询</el-button>
              <el-button type="primary" icon="el-icon-plus" @click="addGroupDialogVisiable = true">新增</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="groupDataTable" highlight-current-row v-loading="" border style="width: 100%;">
            <af-table-column align="center" prop="number" label="唯一编码" width="120">
            </af-table-column>
            <af-table-column align="center" prop="companyName" label="公司名称" width="120">
            </af-table-column>
            <af-table-column align="center"  prop="dockURL" label="对接URL" min-width="300">
            </af-table-column>
            <af-table-column align="center"  prop="pushURL" label="推送URL" min-width="300">
            </af-table-column>
            <af-table-column align="center"  prop="whether" label="是否有效" width="100">
            </af-table-column>
            <af-table-column align="center"  prop="datastatus" label="数据状态" width="100">
            </af-table-column>
            <af-table-column align="center"  prop="time" label="创建时间" min-width="100">
            </af-table-column>
            <af-table-column align="center"  prop="describe" label="描述" min-width="160">
            </af-table-column>
            <af-table-column label="操作" width="220">
              <template slot-scope="scope">
                <el-button size="mini" type="success" @click="details(scope.$index, scope.row)">详情</el-button>
                <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
              </template>
            </af-table-column>
          </el-table>
          <Pagination v-bind:child-msg="pageparm"></Pagination>
        </el-tabs>
        <el-dialog title="新增" :visible.sync="addGroupDialogVisiable" :modal-append-to-body='false'>
          <el-form :model="form">
            <el-row>
              <el-col :span="10">
                <el-form-item label="唯一编码" :label-width="formLabelWidth" class=“required”>
                  <el-input size="mini" autocomplete="off" placeholder="请填写"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="公司名称" :label-width="formLabelWidth">
                  <el-select size="mini" placeholder="所属运营商">
                    <el-option label="腾亿新能源清能" value="1"></el-option>
                    <el-option label="腾亿新能源测试" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="数据状态" :label-width="formLabelWidth">
                  <el-input size="mini" autocomplete="off" placeholder="请填写"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="创建时间" :label-width="formLabelWidth">
                  <el-date-picker size="mini" v-model="val_time" type="datetime" placeholder="选择日期时间">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="addOperatorDialogVisiable = false">取 消</el-button>
            <el-button size="small" type="primary" @click.native="addGroup">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="详情" :visible.sync="groupDetailFormVisible" :modal-append-to-body='false'>
          <el-form :model="groupDetailForm" ref="groupDetailForm" size="mini" class="detail_form">
            <el-collapse v-model="activeNames">
              <el-collapse-item title="基本信息" name="basicInformation">
                <el-col :span="12">
                  <el-form-item label="名 称" :label-width="formLabelWidth" prop="group">
                    <label v-text="groupDetailForm.group"></label>
                  </el-form-item>
                  <el-form-item label="运营商" :label-width="formLabelWidth" prop="operator">
                    <label v-text="groupDetailForm.operator"></label>
                  </el-form-item>
                  <el-form-item label="创建者" :label-width="formLabelWidth" prop="creator">
                    <label v-text="groupDetailForm.creator"></label>
                  </el-form-item>
                  <el-form-item label="联系人" :label-width="formLabelWidth" prop="groupContact">
                    <label v-text="groupDetailForm.groupContact"></label>
                  </el-form-item>
                  <el-form-item label="钱包额度" :label-width="formLabelWidth" prop="walletAmount">
                    <label v-text="groupDetailForm.walletAmount"></label>
                  </el-form-item>
                  <el-form-item label="钱包余额" :label-width="formLabelWidth" prop="walletBalance">
                    <label v-text="groupDetailForm.walletBalance"></label>
                  </el-form-item>
                  <el-form-item label="是否授信" :label-width="formLabelWidth" prop="creditGroupFlag">
                    <label v-text="groupDetailForm.creditGroupFlag"></label>
                  </el-form-item>
                  <el-form-item label="电话号码" :label-width="formLabelWidth" prop="phone">
                    <label v-text="groupDetailForm.phone"></label>
                  </el-form-item>
                </el-col>
              </el-collapse-item>
            </el-collapse>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="walletdetailFormVisible = false">确 定</el-button>
          </div>
        </el-dialog>
        <!--编辑界面-->
        <!--        <el-dialog :visible.sync="editFormVisible"  :modal-append-to-body='false'>-->
        <!--          <el-form :model="editForm" ref="editForm" :rules="editFormRules" size="mini" class="edit_form">-->
        <!--            <el-form-item label="" :label-width="formLabelWidth" prop="stationName">-->
        <!--              <el-input v-model="editForm.stationName" autocomplete="off"></el-input>-->
        <!--            </el-form-item>-->
        <!--            <el-form-item label="" :label-width="formLabelWidth" prop="stationName">-->
        <!--              <el-input v-model="editForm.stationName" autocomplete="off"></el-input>-->
        <!--            </el-form-item>-->
        <!--            <el-form-item label="" :label-width="formLabelWidth" prop="stationName">-->
        <!--              <el-input v-model="editForm.stationName" autocomplete="off"></el-input>-->
        <!--            </el-form-item>-->
        <!--            <el-form-item label="" :label-width="formLabelWidth" prop="stationType">-->
        <!--              <el-select  placeholder="请选择" v-model="editForm.stationType">-->
        <!--                <el-option label="" value="1"></el-option>-->
        <!--                <el-option label="" value="2"></el-option>-->
        <!--              </el-select>-->
        <!--            </el-form-item>-->
        <!--            <el-form-item label="是否可配置" :label-width="formLabelWidth" prop="hasFreePile">-->
        <!--              <el-select  placeholder="请选择" v-model="editForm.hasFreePile">-->
        <!--                <el-option label="否" value="0"></el-option>-->
        <!--                <el-option label="是" value="1"></el-option>-->
        <!--              </el-select>-->
        <!--            </el-form-item>-->
        <!--          </el-form>-->
        <!--          <div slot="footer" class="dialog-footer">-->
        <!--            <el-button size="mini"  type="primary" @click.native="editSubmit" :loading="editSubmitLoading">提交</el-button>-->
        <!--            <el-button size="mini" type="success" @click="editFormVisible = false">重置</el-button>-->
        <!--          </div>-->
        <!--        </el-dialog>-->
      </el-main>
    </el-container>
  </section>
</template>
<script>
  import Pagination from '../../../components/Pagination'

  export default {
    data() {
      return {
        groupInformationManagementTableModel: 'groupInformationManagement',
        groupInformationManagementForm: {
          ownCarrier: '',
          affiliatedGroup: ''
        },
        views: [],
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        groupDataTable: [{}],
        groupDetailForm: [{}],
        groupCarDetailForm: [{}],
        group: [{}],
        activeNames: ['basicInformation', 'bindingInformation', 'dateInformation'],
        listLoading: false,
        addGroupDialogVisiable: false,
        // editFormVisible: false,
        formLabelWidth: '120px',
        groupDetailFormVisible: false,
        groupCustomerDetailFormVisible: false,
        groupCarDetailFormVisible: false
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    watch: {},
    created() {
      this.getdata(this.formInline)
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event)
      },
      details(index, row) {
        this.groupDetailFormVisible = true
        this.groupDetailForm = Object.assign({}, row)
      },
      handleEdit: function (index, row) {
        this.editFormVisible = true
      },
      // 删除用户
      deleteUser(index, row) {
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除！'
            })
          })
      }
    }
  }
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/module/interactionCenter/page/winline.vue